import React from 'react';

function TermsOfService() {
  return (
    <div className="p-8 max-w-3xl mx-auto">
      <h1 className="text-3xl font-bold mb-4">Terms of Service</h1>
      <p className="mb-4">
        By using Home Lead IQ, you agree to be bound by the following terms and conditions.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">1. Use of Platform</h2>
      <p>
        Home Lead IQ is designed to automate lead generation, follow-up, and calendar scheduling. You agree to use it only for lawful purposes.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">2. Accounts & Security</h2>
      <p>
        You are responsible for safeguarding your login credentials. We are not liable for unauthorized use of your account.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">3. Data Responsibility</h2>
      <p>
        You retain full ownership of your leads and data. We store and process your data solely to deliver service features.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">4. Limitation of Liability</h2>
      <p>
        Home Lead IQ is provided “as is” without warranties. We are not responsible for loss of data, revenue, or other damages.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">5. Termination</h2>
      <p>
        We reserve the right to suspend or terminate access if these terms are violated or if suspicious activity is detected.
      </p>

      <p className="mt-6">Effective date: May 29, 2025</p>
    </div>
  );
}

export default TermsOfService;